// TODO: remove all constants and use union type of modus instead
// e.g. type Modus = 'user' | 'userSetting' | ...

export const USER_INFO = 'userInfo_get'
export const USER_SETTING = 'userSetting'
export const USER_UPDATE = 'user'
export const TEMPLATE = 'template'
export const DELETE_COLUMN = 'deleteColumn'
export const FIELD_TYPE_GET = 'fieldType_get'
export const GET_TEMPLATE = 'templates_get'
export const REORDER_TEMPLATES = 'reOrderTemplates'
export const CREATE_CUSTOM_SUB_FIELD = 'createCustomSubField'
export const EDIT_CUSTOM_SUB_FIELD = 'editCustomSubField'
export const DROPDOWN = 'dropdown'
export const GET_ENTRY = 'row_get'
export const UPDATE_ENTRY = 'properties'
export const FILE_UPLOAD = 'fileUpload'
export const GET_MANDATORY_PROPERTIES_VALUES = 'mandatoryPropertiesValues_get'
export const NEW_ROW = 'newRow'
export const GET_HISTORY = 'history_get'
export const GET_TABLE = 'table_get'
export const GET_MANDATORY_PROPERTIES = 'mandatoryProperties_get'
export const USER_AVATAR_LIST = 'userAvatarList'
export const CURRENCY_LIST = 'currencyList'
export const SWITCH_PROJECT = 'switchProjekt'
export const SET_PROJECT = 'setProjekt'
export const LOGOUT = 'logout'
export const GET_FILE_DOWNLOAD = 'fileDownload_get'
export const PASSWORD_ZURUCK = 'passwortzuruck'
export const PROJECT_INFO = 'projekt_info'
export const VALIDATION_PASSWORD_RESET_CODE = 'validatePasswordResetCode'
export const GET_USER = 'user_get'
export const USER_API = 'user'
export const SEARCH_USER_FOR_PROJECT_API = 'searchUserForProject'
export const GET_ROLLS = 'rollen_get'
export const CREATE_NEW_PROJECT = 'createNewProject'
export const GET_PROJECTS = 'projektList_get'
export const REQUEST_FOR_APPROVAL = 'requestForApproval'
export const APPROVAL_LIST = 'approvalList'
export const SET_APPROVAL_STATUS = 'setApprovalStatus'
export const APPROVAL_TODO_LIST = 'approvalToDoList'
export const UPDATE_PROJECT = 'projekt'
export const GET_ADMIN_LIST = 'adminList_get'
export const SEARCH_USER = 'searchUser'
export const UPDATE_USER_ROLE = 'updateUserRole'
export const DELETE_ENTRY = 'row'
export const UN_DELETE_ENTRY = 'rowRollback'
export const EXPORT_PROJECT = 'exportProject_get'
export const COPY_ENTRY = 'rowCopy'
export const REMOVE_USER_FROM_PROJECT = 'removeUserFromProject'
export const COMMENT = 'comment'
